import React from 'react';
import { Hidden, Radio, FormControlLabel } from '@mui/material';

export interface RadioTableOption {
	label: string;
	value: string | number;
	labelSupplement?: JSX.Element;
	additionalLabelContent?: JSX.Element;
	optionDisabled?: boolean;
	hideRadioInput?: boolean;
	isMsp?: boolean;
	requiredForm?: JSX.Element;
}

interface InheritedProps {
	disabled: boolean;
}

export type RadioTableOptionProps = RadioTableOption & InheritedProps;

export function RadioTableOptionDisplay(props: RadioTableOptionProps) {

	const { disabled, value, label, labelSupplement, additionalLabelContent, optionDisabled, hideRadioInput, isMsp, requiredForm } = props;

	const isDisabled = optionDisabled || disabled;


	return (
		<div className={`coverage-table-row ${isMsp ? 'coverage-table-row-blue' : ''} `}>
			<div className='coverage-table-row-cell'>
				<div className={`coverage-table-radio-container ${hideRadioInput ? 'coverage-table-radio-container-hide' : ''}`}>
					<FormControlLabel
						control={
							<Radio
								value={value}
								disabled={isDisabled}
							/>
						}
						label={label}
					/>
					<Hidden xsDown>
						<div className='coverage-table-radio-supplement'>
							{labelSupplement}
						</div>
						{requiredForm && <div className='coverage-table-radio-supplement-form'>
							{requiredForm}
						</div>}
					</Hidden>

				</div>
			</div>
			{additionalLabelContent}

			<Hidden smUp>
				<div className='coverage-table-radio-supplement'>
					{labelSupplement}
				</div>
				{requiredForm && <div className='coverage-table-radio-supplement-form'>
					{requiredForm}
				</div>}
			</Hidden>
		</div>
	);
}

RadioTableOptionDisplay.defaultProps = {
	labelSupplement: null,
	additionalLabelContent: null,
	optionDisabled: false,
	isMsp: false,
	hideRadioInput: false,
	requiredForm: null,
};

export const TestRadioTableOptions: RadioTableOption[] = [
	{
		label: 'Label 1',
		value: 'one',
		labelSupplement: <div><a href='/'>Link</a></div>,
		additionalLabelContent: <div>Additional</div>,
	},
	{
		label: 'Label 2',
		value: 'two',
		labelSupplement: <div><a href='/'>Link2</a></div>,
		additionalLabelContent: <div>Additional 2</div>,
	},
];